import { isSpaceBounded, TtsLocale } from '../Base';
import { ConvertType } from './ConvertType';

export enum QuickCreateGameMode {
  Spelling = 'spelling',
  QuickMemory = 'quickMemory',
}

interface QuickCreateGameModeProps {
  isAvailable: boolean;
  name: string;
  description: string;
  languageList: TtsLocale[] | undefined;
  defaultPercentageSelectionThreshold: number;
  defaultRegularSelectionWordCount: number;
  defaultSelectAllThreshold: number;
  defaultQuestionText: string;
  splitLimitation: number;
  convertType: ConvertType[];
}

const quickCreateGameModeProps: Record<
  QuickCreateGameMode,
  QuickCreateGameModeProps
> = {
  [QuickCreateGameMode.Spelling]: {
    isAvailable: true,
    name: 'Spelling JOY',
    description: 'Accurate spelling practice for dictation, exam, etc.',
    languageList: Object.values(TtsLocale).filter((locale) =>
      isSpaceBounded(locale as TtsLocale),
    ),
    defaultPercentageSelectionThreshold: 20,
    defaultRegularSelectionWordCount: 6,
    defaultSelectAllThreshold: 5,
    defaultQuestionText: 'Rearrange the following text.',
    splitLimitation: 100,
    convertType: [
      ConvertType.FillInTheBlanksBySyllable,
      ConvertType.FillInTheBlanksBySpelling,
    ],
  },
  [QuickCreateGameMode.QuickMemory]: {
    isAvailable: true,
    name: 'Quick Memory JOY',
    description:
      'Quick learning of any massive text content for assessment, exam, etc.',
    languageList: undefined,
    defaultPercentageSelectionThreshold: 0,
    defaultRegularSelectionWordCount: 0,
    defaultSelectAllThreshold: 7,
    defaultQuestionText: 'Fill in the blanks.',
    splitLimitation: 150,
    convertType: [ConvertType.JoyaPassage],
  },
};

export const getQuickCreateGameModeProps = (mode: QuickCreateGameMode) => {
  return quickCreateGameModeProps[mode];
};
